// 1st Party
import { quote } from './elements';
import { quoteRedirect, addressRedirect } from './quote-workflows';
import { showPopoverErrorsCallback } from './validation-methods';

const validationEnableButton = (e) => {
    if (
        quote.property.fullAddress.val().length >= 5 &&
        quote.property.unitNumber.val().length >= 0 &&
        quote.property.unitNumber.val().length <= 10 &&
        quote.occupancyInput.val().length > 0 &&
        quote.newPurchase.is(':checked')
    ) {
        quote.button.prop('disabled', '');
    } else {
        quote.button.prop('disabled', 'disabled');
    }
};

const quoteBoxValidatorOptions = {
    submitHandler: async (form, e) => { await quoteRedirect(form, e); },

    rules: {
        'Insured.FirstName': {
            required: true,
            noEmpty: true
        },
        'Insured.MiddleName': {
            maxlength: 20,
            noEmptyOptional: true
        },
        'Insured.LastName': {
            required: true,
            noEmpty: true
        },
        'EmailAddress': {
            customEmail: true,
            noEmptyOptional: true
        },
        'PhoneNumber': {
            maxlength: 10,
            minlength: 10,
            noEmptyOptional: true
        },
        'Insured.Address.FullAddress': {
            required: true,
            noEmpty: true
        },
        'Insured.Address.UnitNumber': {
            maxlength: 10,
            noEmptyOptional: true
        },
        'PropertyAddress.FullAddress': {
            required: true,
            noEmpty: true
        },
        'PropertyAddress.UnitNumber': {
            maxlength: 10,
            noEmptyOptional: true
        }
    },

    onkeyup: function (element) {
        if ($(element).valid()) {
            $(element)
                .removeClass('is-invalid')
                .addClass('is-valid');
        } else {
            $(element)
                .removeClass('is-valid')
                .addClass('is-invalid');
        }
    },

    showErrors: function (errorMap, errorList) {
        let boundShowPopoverErrorsCallback = showPopoverErrorsCallback.bind(this);
        return boundShowPopoverErrorsCallback(errorMap, errorList, 'top');
    }
};

const addressPageValidatorOptions = {
    submitHandler: async (form, e) => { await addressRedirect(form, e); },

    rules: {
        'PropertyAddress.StreetAddress': {
            required: true,
            noEmpty: true
        },
        'PropertyAddress.ZipCode5': {
            googleZipcode: true,
            required: true,
            digits: true,
            minlength: 5,
            maxlength: 5,
            noEmpty: true
        }
    },

    onkeyup: function (element) {
        if ($(element).valid()) {
            $(element)
                .removeClass('is-invalid')
                .addClass('is-valid');
        }
    },

    showErrors: function (errorMap, errorList) {
        let boundShowPopoverErrorsCallback = showPopoverErrorsCallback.bind(this);
        return boundShowPopoverErrorsCallback(errorMap, errorList, 'top');
    }
};

const espanolQuoteBoxValidatorOptions = {
    submitHandler: async (form, e) => { form.submit(); },

    rules: {
        'EspanolEmail.FullAddress': {
            required: true,
            noEmpty: true
        },
        'EspanolEmail.Occupancy': {
            required: true,
            noEmpty: true
        },
        'EspanolEmail.FirstName': {
            required: true,
            noEmpty: true
        },
        'EspanolEmail.LastName': {
            required: true,
            noEmpty: true
        },
        'EspanolEmail.PhoneNumber': {
            required: true,
            phoneUS: true,
            noEmpty: true
        },
        'EspanolEmail.Email': {
            required: false,
            customEmail: true,
            noEmptyOptional: true
        },
        'EspanolEmail.IsNewPurchase': {
            required: true,
            noEmpty: true
        }
    },

    onkeyup: function (element) {
        if ($(element).valid()) {
            $(element)
                .removeClass('is-invalid')
                .addClass('is-valid');
        }
    },

    showErrors: function (errorMap, errorList) {
        let boundShowPopoverErrorsCallback = showPopoverErrorsCallback.bind(this);
        return boundShowPopoverErrorsCallback(errorMap, errorList, 'top');
    }
};

quote.form.validate(quoteBoxValidatorOptions);
quote.addressForm.validate(addressPageValidatorOptions);
quote.espanolForm.validate(espanolQuoteBoxValidatorOptions);

export {
    validationEnableButton
};